import React from "react";
import { Button, Classes, Dialog, DialogProps } from "@blueprintjs/core";

/**
 * TermsOfServiceDialog
 */
export const TermsOfServiceDialog: React.FC<DialogProps> = (props) => {
	return (
		<Dialog
			{...props}
			isCloseButtonShown={true}
			title='Terms of service'
			style={{
				background: "#fff",
				width: "90vw",
				maxWidth: 1500,
			}}
		>
			<div className={Classes.DIALOG_BODY} style={{ height: "80vh", maxHeight: 1400, position: "relative" }}>
				<iframe
					className='uk-position-cover'
					src='https://colltrain.com/terms-and-conditions/'
					style={{ margin: 0, overflow: "auto", width: "100%", height: "100%" }}
				/>
			</div>

			<div className={Classes.DIALOG_FOOTER}>
				<div className={Classes.DIALOG_FOOTER_ACTIONS}>
					<Button text='Close' onClick={props.onClose} />
				</div>
			</div>
		</Dialog>
	);
};
